(function($) {

  	// DOM is fully loaded, safe to manipulate elements
  	$(function() {	

  		const $smBlock = $('.parcel-social-media');

		$('.parcel-social-media .headlabel a').each( function(i) {

			$(this).on('click', function(e) {

				e.preventDefault();

				$(this)
					.addClass('active')
					.closest('.headlabel')
					.siblings()
					.find('a')
					.removeClass('active');

				const targetAttr = $(this).attr('data-target'),
				 	  $target 	 = $smBlock.find('.sm__feed[data-feed="' + targetAttr + '"]');

				$('.sm__feed.feed--hidden').show();

				if ( undefined !== targetAttr ) {

					$('.sm__feed').addClass('feed--hidden').not($target).hide();

				} else {

					$('.sm__feed').each(function() {
						$(this).show();
					})

				}

				//console.log(targetAttr);
				//console.log($target);

			})

		})

	});

})(jQuery);